import { useFadeInScroll } from "../../components/Animation/fadeinScroll";
const BlogHero = () => {
   const title = useFadeInScroll<HTMLDivElement>();
  return (
    <section className="text-center">
        <div
            ref={title.ref}
            className={`
              transition-all duration-[900ms] ease-[cubic-bezier(0.22,1,0.36,1)]
              ${title.isVisible
                ? "opacity-100 translate-y-0"
                : "opacity-0 translate-y-6"}
            `}
          >
   <h2
            className="
            text-primary font-semibold leading-tight
            text-[1.6rem]
            sm:text-[2.1rem]
            md:text-[2.5rem]
            lg:text-[2.8rem]
            xl:text-[3rem]
            mb-4 sm:mb-5
          "
          >
        Inside & Articles
      </h2>
</div>
      <p className="mt-4 max-w-2xl mx-auto text-gray-500">
        Explore the latest innovations, medical insights, and stories shaping
        the future of orthopedic care.
      </p>
      
    </section>
  );
};

export default BlogHero;
